module.exports = __webpack_public_path__ + "static/media/chart-table.312a7429.svg";